var Backbone = require('backbone');
var _ = require('underscore');
var svg4everybody = require('svg4everybody');
var FontFaceObserver = require('fontfaceobserver');
//var FastClick = require('fastclick/lib/fastclick.js');


//Backend urls chhemas to generate them on frontend
window.Urls = require('django_js_submissions/reverse.js').Urls;
window.UrlsFront = require('reverse.js').Urls;

//to be on top of all styles
//to left other styles chance to override it without !important and other magic
require('front/text.less');

var Settings = require('front/Settings');
var Router = require('./Router');
var Utils = require('front/utils/Utils.js');

require('submissions/components/Content/Content');

var Footer = require('submissions/components/Footer/Footer');
var TopNav = require('submissions/components/TopNav/TopNav');

require('reset.css');
require('front/style.less');
require('front/utils.less');
require('front/fonts.less');
require('mq.genie-0.5.0.js');

//fix for hovers|active on mobile, what a weird behavior!
//fastclick solves this problem, but adds a bunch of other
if (!app.settings.isDesktop) {
    $('body *').on('touchstart', function () {});
}



app.AdoptTempFileObject = function (responseText, dataType) {
    var parsedData = JSON.parse(responseText);
    var responseObject = {};

    if (dataType == 'image') {
        responseObject = {
            aspect: parsedData.aspect,
            width: parsedData.width,
            height: parsedData.height,
            tempImg: parsedData.url,
            tempImgId: parsedData.id
        };
    }

    if (dataType == 'file') {
        responseObject = {
            originalName: parsedData.originalName,
            mime: parsedData.mime[0],
            typ: parsedData.mime[0].split('/')[1],
            tempFile: parsedData.url,
            tempFileId: parsedData.id
        };
    }

    return responseObject;
};




import Promise from 'promise-polyfill';

if (!window.Promise) {
    window.Promise = Promise;
}


//Pervushinag закомментил, потому что в IE9-11 вместо того чтобы делать все хорошо, делает все плохо и все use внутри svg просто выпилпвает
//для случая когда свг с символами уже встроен в дум svg4everybody не только не нужен, но и вреден
//svg4everybody();



//turn it off, too buggy, 300ms lag can be eliminated in more simple way: css touch-action: manipulation;
// $(function () {
//     if (!app.settings.isDesktop) {
//         FastClick.attach(document.body);
//     }
// });

app.configure = Settings.configure;
app.configure();

window.app.vent = _.extend({}, Backbone.Events);

var futuraNormal = new FontFaceObserver('FuturaNormal');
var athelasNormal = new FontFaceObserver('AthelasNormal');

Promise.all([futuraNormal.load(), athelasNormal.load()]).then(function () {
    console.log('Fonts loaded');
    window.app.state.fontsLoaded = true;
    window.app.vent.trigger('fonts-loaded');
}, function () {
    console.log('Fonts is not available');
});


window.app.utils = Utils;

window.app.els = {
    $window: $(window),
    $body: $('body'),
    $htmlBody: $('html,body'),
    $content: $('.Content'),
    $topNav: $('.TopNav')
};

window.app.isPhoneLayout = function () {
    return window.innerWidth < 768;
};


// $.get(window.app.settings.staticUrl + 'svg/front/symbol/svg/sprite.symbol.svg', function (data) {
$.get('/static/svg/front/symbol/svg/sprite.symbol.svg', function (data) {
    var div = document.createElement('div');
    div.style.display = 'none';
    div.innerHTML = new XMLSerializer().serializeToString(data.documentElement);
    document.body.insertBefore(div, document.body.childNodes[0]);
});

app.router = new Router();

app.els.$body.on('click', '.u-Route', function (e) {
    if (app.els.$body.hasClass('Page404')) {
        return;
    }

    var currentRoute = Backbone.history.getFragment();

    var parentUrl = $(e.target)
        .closest('a')
        .attr('href');

    var url = $(e.currentTarget).attr('href') || parentUrl;

    e.preventDefault();
    Backbone.history.navigate(url, {trigger: 'true'});
});


_.extend(app.views, {
    topNav: new TopNav({
        el: $('.TopNav')
    }),
    footer: new Footer({
        el: $('.Footer')
    })
});




$.fn.flashClass = function (className, delay) {
    var self = this;
    var timeout;
    this.addClass(className);
    clearTimeout(this.data('timeout'));
    timeout = setTimeout(function () {
        if (typeof self == 'object' && self.length) {
            self.removeClass(className);
            self.data('timeout', null);
        }
    }, delay);
    this.data('timeout', timeout);

    return this;
};


app.animateWindowScroll = function (scrollTop) {
    app.state.preventMenuShowOnScroll = true;
    $('body, html').animate({'scrollTop': scrollTop}, 400);

    setTimeout(function () {
        app.state.preventMenuShowOnScroll = false;
    }, 500);
};


app.vent.on('hide-footer', function () {
    $('.Content').addClass('Content--no-footer');
    $('.Footer').hide();
});


app.vent.on('make-logout', function () {
    $.ajax(Urls['submissions:api:logout'](), {
        method: 'GET',
        contentType: 'application/json; charset=utf-8',
        'success': function (data) {
            window.location.href = Urls['submissions:submissions']();
        },
        'error': function (data) {
            console.log(data);
        }
    });
});

//proceed any popup show/hide
//set all underlying content fixed position
app.vent.on('PopupShown', function () {
    var $items = [];
    var tops = [];
    var scrollTop = $(window).scrollTop();

    //first of all get top position of all elements that need to be fixed on popup shown
    $('.NeedFixOnPopup').each(function (id, item) {
        var $item = $(item);
        $items.push($item);
        tops.push($item.offset().top);
    });

    //after that set all items fixed position and position them at the very point there where they was
    _.each($items, function ($item, ind) {
        $item
            .css('top', tops[ind] - scrollTop)
            .addClass('FixedOnPopup');
    });

    app.state.popupShown = true;

    $(window).resize();
});

app.vent.on('PopupHidded', function () {
    $('.NeedFixOnPopup').each(function (id, item) {
        $(item)
            .css('top', '')
            .removeClass('FixedOnPopup');
    });

    app.state.popupShown = false;
    $(window).resize();
});


app.router.start();



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/App.js
// module id = 102
// module chunks = 0